const config = {};

if (process.env.VUE_APP_ENV) {
    config.env = process.env.VUE_APP_ENV;
    config.reqiestUrl = process.env.VUE_APP_REQUIEST_BASE_URL;
} else {
    config.env = 'SIT';
    config.reqiestUrl = '//anapi-uat.annto.com';
}

export default config;
